import { render, staticRenderFns } from "./transfer-add.vue?vue&type=template&id=6cef0104&scoped=true&"
import script from "./transfer-add.vue?vue&type=script&lang=js&"
export * from "./transfer-add.vue?vue&type=script&lang=js&"
import style0 from "./transfer-add.vue?vue&type=style&index=0&id=6cef0104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cef0104",
  null
  
)

export default component.exports